module.exports = __webpack_public_path__ + "img/draw-gift.c49c3545.png";